import 'angular:locale/data:sl';
import 'zone.js';(globalThis.$localize ??= {}).locale = "sl";
